<template>
  <div>
    <loading-component :value="loading" />
    <div id="map">
      <!-- <v-layout column class="legend">
        <v-flex
          xs6
          v-for="(value, key) of colors"
          :class="{ 'legend-item': true, crossed: !visible[key] }"
          @click="visible[key] = !visible[key]"
        >
          <v-chip :color="value"></v-chip>
          {{ key.split("_")[0] }}
        </v-flex>
      </v-layout> -->
      <!-- <div :class="{ title: true, visible: !!selectedTitle }">
        <div>
          {{ selectedTitle }} ({{
            selected.type && selected.type.split("_")[0]
          }})
        </div>
      </div> -->
      <!-- <div class="filter-ctrl">
        <input
          id="filter-input"
          type="text"
          name="filter"
          placeholder="Filter by name"
          v-model="search"
        />
      </div>
      <div
        class="active-mode"
        :style="'background-color: ' + colors[active_mode]"
        @click="switchMode"
      >
        {{ active_mode }}
      </div> -->
    </div>
  </div>
</template>

<script>
import Mapbox from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "MapEditor",
  components: { LoadingComponent },
  title() {
    return this.$t("routeTitles.mapEditor");
  },
  data() {
    return {
      drawComponent: null,
      map: null,
      loading: false,
      whitelist_polygons: [],
      blacklist_polygons: [],
      landmarks: [],
      containers: [],
      active_mode: "whitelist_polygons",
      visible: {
        whitelist_polygons: true,
        blacklist_polygons: true,
        containers: false,
      },
      selected: {
        type: null,
        index: null,
      },
      search: "",
    };
  },
  mounted() {
    Mapbox.accessToken = this.api.mapBox.accessToken;
    this.loadMap();
    this.getData();
  },
  watch: {
    search() {
      this.updateData();
    },
    visible: {
      handler() {
        this.updateData();
      },
      deep: true,
    },
  },
  computed: {
    colors() {
      return {
        whitelist_polygons: "#4CAF50",
        blacklist_polygons: "#F44336",
        containers: "#9C27B0",
      };
    },
    dataTypes() {
      return {
        whitelist_polygons: this.api.ACTIONS.LOCATIONS,
        blacklist_polygons: this.api.ACTIONS.BLACKLIST_LOCATIONS,
        landmarks: this.api.ACTIONS.LANDMARKS,
        containers: this.api.ACTIONS.LOCATION_CONTAINERS,
      };
    },
    selectedTitle() {
      if (
        !this.selected.type ||
        this[this.selected.type].length <= this.selected.index ||
        !this[this.selected.type][this.selected.index].draw_component_id
      )
        return null;
      return this[this.selected.type][this.selected.index].name;
    },
  },
  methods: {
    switchMode() {
      const modes = ["whitelist_polygons", "blacklist_polygons", "containers"];

      this.active_mode =
        modes[(modes.indexOf(this.active_mode) + 1) % modes.length];
    },
    drawOfType(dataKey) {
      for (let i = 0; i < this[dataKey].length; i++)
        this.drawPolygonWithProperties(dataKey, i++);
    },
    drawPolygonWithProperties(dataKey, i) {
      const drawComponentId = this.drawComponent.add(this[dataKey][i].polygon);
      this[dataKey][i].draw_component_id = drawComponentId[0];
      this.addProperties(drawComponentId[0], dataKey, i);
    },
    addProperties(drawComponentId, dataKey, i) {
      this.drawComponent.setFeatureProperty(
        drawComponentId,
        "portColor",
        this.colors[dataKey]
      );
      this.drawComponent.setFeatureProperty(drawComponentId, "type", dataKey);
      this.drawComponent.setFeatureProperty(drawComponentId, "index", i);
    },
    updateData() {
      for (let key in this.visible) {
        this[key].forEach(({ name, draw_component_id }, idx) => {
          const found = name.search(this.search) !== -1;
          const keyVisible = this.visible[key];

          if (found && keyVisible) {
            if (draw_component_id) return;
            this.drawPolygonWithProperties(key, idx);
          } else {
            if (!draw_component_id) return;
            this.drawComponent.delete(draw_component_id);
            this[key][idx].draw_component_id = null;
          }
        });
      }
      this.selected = JSON.parse(JSON.stringify(this.selected));
      if (!this.selectedTitle)
        this.selected = {
          type: null,
          index: null,
        };
    },
    async getData() {
      this.loading = true;
      for (let dataKey in this.dataTypes) {
        const apiLink = this.dataTypes[dataKey];
        let pagesCount = null;
        for (let page = 1; page <= pagesCount || pagesCount === null; page++) {
          const params = new URLSearchParams();
          params.append("page", page);
          params.append("perPage", 100);
          const {
            data: { data: paginator },
          } = await this.axios.get(apiLink, { params });
          pagesCount = paginator.last_page;
          const data = paginator.data;
          this[dataKey] = [...this[dataKey], ...data];
        }
      }
      for (let dataKey of [
        "whitelist_polygons",
        "blacklist_polygons",
        "containers",
      ])
        this.drawOfType(dataKey);
      this.updateData();
      this.loading = false;
    },
    loadMap() {
      this.map = new Mapbox.Map(
        Object.assign({ container: "map" }, this.api.mapBox)
      );
      this.drawComponent = new MapboxDraw({
        displayControlsDefault: false,
        userProperties: true,
        controls: {
          polygon: true,
          trash: true,
          marker: true,
        },
        styles: [
          {
            id: "gl-draw-polygon-fill-inactive",
            type: "fill",
            filter: ["all", ["has", "user_portColor"]],
            paint: {
              "fill-color": ["get", "user_portColor"],
              "fill-opacity": 0.5,
            },
          },
          {
            id: "gl-draw-polygon-fill-active",
            type: "fill",
            filter: [
              "all",
              ["==", "active", "true"],
              ["==", "$type", "Polygon"],
            ],
            paint: {
              "fill-color": "#fbb03b",
              "fill-outline-color": "#fbb03b",
              "fill-opacity": 0.1,
            },
          },
          {
            id: "gl-draw-polygon-midpoint",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["==", "meta", "midpoint"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#fbb03b",
            },
          },
          {
            id: "gl-draw-polygon-stroke-inactive",
            type: "line",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Polygon"],
              ["!=", "mode", "static"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#3bb2d0",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-polygon-stroke-active",
            type: "line",
            filter: [
              "all",
              ["==", "active", "true"],
              ["==", "$type", "Polygon"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#fbb03b",
              "line-dasharray": [0.2, 2],
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-line-inactive",
            type: "line",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "LineString"],
              ["!=", "mode", "static"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#3bb2d0",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-line-active",
            type: "line",
            filter: [
              "all",
              ["==", "$type", "LineString"],
              ["==", "active", "true"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#fbb03b",
              "line-dasharray": [0.2, 2],
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-polygon-and-line-vertex-stroke-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "meta", "vertex"],
              ["==", "$type", "Point"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-color": "#fff",
            },
          },
          {
            id: "gl-draw-polygon-and-line-vertex-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "meta", "vertex"],
              ["==", "$type", "Point"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#fbb03b",
            },
          },
          {
            id: "gl-draw-point-point-stroke-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Point"],
              ["==", "meta", "feature"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-opacity": 1,
              "circle-color": "#fff",
            },
          },
          {
            id: "gl-draw-point-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Point"],
              ["==", "meta", "feature"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#3bb2d0",
            },
          },
          {
            id: "gl-draw-point-stroke-active",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["==", "active", "true"],
              ["!=", "meta", "midpoint"],
            ],
            paint: {
              "circle-radius": 7,
              "circle-color": "#fff",
            },
          },
          {
            id: "gl-draw-point-active",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["!=", "meta", "midpoint"],
              ["==", "active", "true"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-color": "#fbb03b",
            },
          },
          {
            id: "gl-draw-polygon-fill-static",
            type: "fill",
            filter: [
              "all",
              ["==", "mode", "static"],
              ["==", "$type", "Polygon"],
            ],
            paint: {
              "fill-color": "#404040",
              "fill-outline-color": "#404040",
              "fill-opacity": 0.1,
            },
          },
          {
            id: "gl-draw-polygon-stroke-static",
            type: "line",
            filter: [
              "all",
              ["==", "mode", "static"],
              ["==", "$type", "Polygon"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#404040",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-line-static",
            type: "line",
            filter: [
              "all",
              ["==", "mode", "static"],
              ["==", "$type", "LineString"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#404040",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-point-static",
            type: "circle",
            filter: ["all", ["==", "mode", "static"], ["==", "$type", "Point"]],
            paint: {
              "circle-radius": 5,
              "circle-color": "#404040",
            },
          },
        ],
      });
      this.map.addControl(new Mapbox.FullscreenControl());
      this.map.addControl(this.drawComponent);
      this.map.on("draw.selectionchange", this.selectionChanged);
      this.map.on("draw.create", this.updateArea);
      this.map.on("draw.delete", this.updateArea);
      this.map.on("draw.update", this.updateArea);
    },
    async deletePolygon(e) {
      this.loading = true;
      const type = e.features[0].properties.type;
      const index = e.features[0].properties.index;
      const id = this[type][index].id;
      await this.axios.delete(this.dataTypes[type] + "/" + id);
      this[type] = this[type].filter(({ id: itemId }) => itemId !== id);
      this.loading = false;
      if (this.selected.type === type && this.selected.index === index) {
        this.selected.type = null;
        this.selected.index = null;
      }
    },
    async updateArea(e) {
      console.log(e);
      if (e.type === "draw.create") await this.createPolygon(e);
      else if (e.type === "draw.update") await this.updatePolygon(e);
      else if (e.type === "draw.delete") await this.deletePolygon(e);
      this.updateData();
    },
    async createPolygon(e) {
      this.addProperties(
        e.features[0].id,
        this.active_mode,
        this[this.active_mode].length
      );
      const name = prompt("Enter a name for the area you just drew");
      if (!name) {
        this.drawComponent.delete(e.features.map((i) => i.id));
        return;
      }
      const polygon = e.features[0].geometry;
      const radius = 10;
      this.loading = true;
      const {
        data: { data },
      } = await this.axios.post(this.dataTypes[this.active_mode], {
        name,
        polygon,
        radius,
      });
      this[this.active_mode] = [
        ...this[this.active_mode],
        {
          ...data,
          draw_component_id: e.features[0].id,
        },
      ];
      this.loading = false;
    },
    async updatePolygon(e) {
      const type = e.features[0].properties.type;
      const index = e.features[0].properties.index;
      const id = this[type][index].id;
      this.loading = true;
      await this.axios.put(this.dataTypes[type] + "/" + id, {
        polygon: e.features[0].geometry,
      });
      this[type] = this[type].map((item) => {
        const { id: itemId } = item;
        if (itemId !== id) return item;
        return { ...item, polygon: e.features[0].geometry };
      });
      this.loading = false;
    },
    selectionChanged(e) {
      console.log(e);
      let notHidden = e.features.filter((x) => !x.properties.hide);
      const selected = notHidden.length ? [notHidden[0]] : [];
      this.drawComponent.changeMode("simple_select", {
        featureIds: selected.map((x) => x.id),
      });

      this.selected.type = selected.length ? selected[0].properties.type : null;
      this.selected.index = selected.length
        ? selected[0].properties.index
        : null;
    },
  },
};
</script>

<style scoped>
@import "~@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

#map {
  width: 100%;
  height: calc(100vh - 64px - 50px);
}

body {
  overflow: hidden;
}

.legend {
  position: absolute;
  z-index: 100;
  background-color: #ffffffaa;
  border-radius: 20px;
  padding: 10px;
  font-weight: bold;
}

.legend-item {
  cursor: pointer;
}

.crossed {
  text-decoration: line-through;
}

.title {
  position: absolute;
  top: 20px;
  inset-inline-start: calc(50vw - 48px);
  background-color: #ffffff88;
  padding: 16px;
  transition: opacity 200ms ease-in;
  opacity: 0;
  z-index: 3;
}

.title.visible {
  opacity: 1;
}

.search-bar {
  position: absolute;
  z-index: 10;
  inset-inline-start: 200px;
  background-color: #ffffffdd;
}

.filter-ctrl {
  position: absolute;
  top: 10px;
  inset-inline-end: 50px;
  z-index: 1;
  width: 180px;
}

.filter-ctrl input[type="text"] {
  font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
  width: 100%;
  border: 0;
  background-color: #fff;
  height: 40px;
  margin: 0;
  color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.active-mode {
  position: absolute;
  top: 50px;
  inset-inline-end: 50px;
  z-index: 1;
  width: 180px;
  text-align: center;
  color: white;
  font-size: 1.3rem;
  cursor: pointer;
  user-select: none;
}
</style>
